import axios from 'axios';
import MicroModal from 'micromodal';
import {getCommonVars} from "../common/common.js";
import {replaceModalContentAndOpen, showLoginModal} from "../app.js";
import {initTabs} from "../common/tabs.js";
import {choises} from "../common/choises.js";

export default class SelfPickup {
	constructor() {
		const {maskPhoneFormat, baseUrl} = getCommonVars();
		this.selfPickupModalContainer = document.querySelector('.js-append-popup');
		this.baseUrl = baseUrl || window.commonVars.baseUrl;
		this.phoneMask = maskPhoneFormat;
		this._selfPickupMap = null;
		this._selfPickupMarkers = [];
		this._selfPickupInfoWindows = [];
		this._selfPickupLastTrigger = null;
		this._i18n = {};
		this._handleModalShow = this.handleModalShow.bind(this);

		if (!this.selfPickupModalContainer) {
			console.error('SelfPickup: .js-append-popup container not found');
			return;
		}
		this.init();
	}

	rememberI18n(source) {
		if (!source?.dataset) return;
		this._i18n = {
			...this._i18n,
			...source.dataset,
		};
	}

	getI18n(key, fallback, source = null) {
		if (source?.dataset?.[key]) return source.dataset[key];
		if (this._i18n?.[key]) return this._i18n[key];
		return fallback;
	}

	init() {
		document.body.addEventListener('click', this.handleBodyClick.bind(this));
		document.body.addEventListener('submit', this.handleBodySubmit.bind(this));
		document.addEventListener('micromodal:show', this._handleModalShow);
	}

	handleModalShow(event) {
		const type = event?.detail?.type;
		if (type !== 'self-pickup') return;
		const modal = event?.detail?.modal || this.selfPickupModalContainer;
		this.initSelfPickupModal(modal);
	}

	handleBodySubmit(e) {
		const form = e.target.closest('form.js-reserveform');
		if (!form) return;
		e.preventDefault();
		const submitBtn = form.querySelector('button[type="submit"]');
		if (submitBtn) submitBtn.disabled = true;
		this.reserveFormSubmit(form);
	}

	makeModalStatic() {
		this.selfPickupModalContainer.removeAttribute('data-micromodal-close');
	}

	makeModalClosable() {
		this.selfPickupModalContainer.setAttribute('data-micromodal-close', '');
	}

	handleBodyClick(e) {
		const btn = e.target.closest('.js-self-pickup');
		const reserveBtn = e.target.closest('.js-reserve');
		if (btn) {
			e.preventDefault();
			this._selfPickupLastTrigger = btn;
			const settlementId = btn.getAttribute('data-settlementid');
			if (!settlementId) {
				console.error('SelfPickup: data-settlementid attribute is required');
				return;
			}
			const packingId = this.getPackingId(btn);
			if (!packingId) {
				console.error('SelfPickup: packing_id input not found');
				return;
			}
			this.loadSelfPickupForm(btn, settlementId, packingId);
		}
		if (reserveBtn) {
			e.preventDefault();
			reserveBtn.disabled = true;
			this.reserveForm(reserveBtn);
		}
	}

	reserveForm(button) {
		const i18nSource = button.closest('.popup-block--map') || button;
		this.rememberI18n(i18nSource);

		const packingid = button.dataset.packingid;
		if (!packingid) {
			window.showErrorModal(
				this.getI18n('i18nPackingMissing', 'Идентификатор фасовки отсутствует. Попробуйте еще раз.', i18nSource)
			);
			return;
		}
		const warehouseid = button.dataset.warehouseid;
		if (!warehouseid) {
			window.showErrorModal(
				this.getI18n('i18nWarehouseMissing', 'Идентификатор магазина отсутствует. Попробуйте еще раз.', i18nSource)
			);
			return;
		}
		MicroModal.close('global-popup', {
			awaitCloseAnimation: true
		});
		this.selfPickupModalContainer.innerHTML = '';

		axios.post(this.baseUrl + '/orders/reserveform', {packingid, warehouseid})
			.then(async (resp) => {
				const data = resp.data;
				if (data.error) {
					button.disabled = false;
					this.makeModalClosable();
					return window.showErrorModal(data.error);
				}
				if (data.login && 1 === +data.login) {
					button.disabled = false;
					showLoginModal();
				}
				if (!data.html) return;
				this.makeModalStatic();
				await replaceModalContentAndOpen({
					html: data.html,
					type: 'reserve',
					id: 'global-popup',
					containerSel: '.js-append-popup'
				});
				this.initReserveCounter(this.selfPickupModalContainer);
			})
			.catch(err => {
				button.disabled = false;
				this.makeModalClosable();
				console.error('SelfPickup: Error submitting reserve form', err);
				window.showErrorModal(
					this.getI18n('i18nReserveSubmitError', 'Произошла ошибка при отправке формы. Попробуйте позже.', i18nSource)
				);
			});
	}

	initReserveCounter(container) {
		if (!container) return;

		const updateCounterState = (counter) => {
			if (!counter) return;
			const input = counter.querySelector('.js-adult-input-reserve');
			const minusBtn = counter.querySelector('.js-count-minus-reserve');
			const plusBtn = counter.querySelector('.js-count-plus-reserve');
			if (!input || !minusBtn || !plusBtn) return;

			const min = parseInt(input.dataset.min || '1', 10);
			const rawMax = parseInt(input.dataset.max || plusBtn.dataset.max || '1', 10);
			const max = Number.isNaN(rawMax) || rawMax < min ? min : rawMax;
			let value = parseInt(input.value, 10);
			if (Number.isNaN(value) || value < min) value = min;
			if (value > max) value = max;
			input.value = String(value);

			minusBtn.classList.toggle('disabled', value <= min);
			plusBtn.classList.toggle('disabled', value >= max);
			minusBtn.disabled = value <= min;
			plusBtn.disabled = value >= max;
		};

		container.addEventListener('click', (e) => {
			const minusBtn = e.target.closest('.js-count-minus-reserve');
			const plusBtn = e.target.closest('.js-count-plus-reserve');
			if (!minusBtn && !plusBtn) return;

			const counter = (minusBtn || plusBtn).closest('.js-count-prod');
			const input = counter?.querySelector('.js-adult-input-reserve');
			if (!counter || !input) return;

			const min = parseInt(input.dataset.min || '1', 10);
			const rawMax = parseInt(input.dataset.max || plusBtn?.dataset.max || '1', 10);
			const max = Number.isNaN(rawMax) || rawMax < min ? min : rawMax;
			let value = parseInt(input.value, 10);
			if (Number.isNaN(value) || value < min) value = min;

			if (minusBtn && value > min) {
				value -= 1;
			}
			if (plusBtn && value < max) {
				value += 1;
			}

			input.value = String(value);
			updateCounterState(counter);
		});

		container.addEventListener('input', (e) => {
			const input = e.target.closest('.js-adult-input-reserve');
			if (!input) return;

			input.value = input.value.replace(/\D/g, '');
			const counter = input.closest('.js-count-prod');
			if (input.value === '') {
				const minusBtn = counter?.querySelector('.js-count-minus-reserve');
				if (minusBtn) {
					minusBtn.classList.add('disabled');
					minusBtn.disabled = true;
				}
				return;
			}

			updateCounterState(counter);
		});

		container.addEventListener('blur', (e) => {
			const input = e.target.closest('.js-adult-input-reserve');
			if (!input) return;
			updateCounterState(input.closest('.js-count-prod'));
		}, true);

		container.querySelectorAll('.js-count-prod').forEach(updateCounterState);
	}

	getPackingId(button = null) {
		const catalogCard = button?.closest('.product-card, .mini-card');
		const productCard = document.getElementById('product-card');
		const selectedCatalogPacking = catalogCard?.querySelector('.js-packing.active')?.dataset.packing;

		return button?.dataset.packingid
			|| selectedCatalogPacking
			|| catalogCard?.dataset.packing
			|| productCard?.dataset.packing
			|| null;
	}

	loadSelfPickupForm(btn, settlementId, packingId) {
		this.rememberI18n(btn);

		axios.post(this.baseUrl + '/product/availabilitypopup', {settlementid: settlementId, packingid: packingId})
			.then(async (resp) => {
				const data = resp.data;
				if (data.error) {
					btn.disabled = false;
					this.makeModalClosable();
					return window.showErrorModal(data.error);
				}
				if (data.login && 1 === +data.login) {
					btn.disabled = false;
					showLoginModal();
				}
				if (!data.html) return;
				this._selfPickupMap = null;
				this._selfPickupMarkers = [];
				this.makeModalStatic();
				await replaceModalContentAndOpen({
					html: data.html,
					type: 'self-pickup',
					id: 'global-popup',
					containerSel: '.js-append-popup'
				});
				try {
					await this.loadGoogleMapForSelfPickup(data.googleMapJs);
				} catch (e) {
					console.error(e);
				}
				this.initSelfPickupModal(this.selfPickupModalContainer);
			})
			.catch(err => {
				btn.disabled = false;
				this.makeModalClosable();
				console.error('SelfPickup: Error loading self-pickup form', err);
				window.showErrorModal(
					this.getI18n('i18nLoadError', 'Произошла ошибка при загрузке формы. Попробуйте позже.', btn)
				);
			});
	}

	initSelfPickupModal(container) {
		if (!container) return;
		const root = container.querySelector('.popup-block--map') || container;
		choises(root);
		initTabs(root);
		this.updateSelectCity(root);

		const mapBlock = root.querySelector('.js-shop-map');
		if (!mapBlock) return;

		const mapTabBtn = root.querySelector('.js-tabs-button[data-id="map"]');
		const ensureMapInited = () => {
			requestAnimationFrame(() => {
				this.initSelfPickupMap(root);
			});
		};

		setTimeout(() => this.initSelfPickupMap(root), 180);
 		setTimeout(() => this.autoSelectShopByAddress(root), 220);

		if (mapTabBtn && !mapTabBtn.dataset.selfPickupMapBound) {
			mapTabBtn.dataset.selfPickupMapBound = '1';
			mapTabBtn.addEventListener('click', () => {
				ensureMapInited();
				setTimeout(() => this.initSelfPickupMap(root), 120);
			});
		}

		if (mapBlock.classList.contains('is-active')) {
			ensureMapInited();
		}
	}

	autoSelectShopByAddress(container) {
		const markerChoose = this._selfPickupLastTrigger?.getAttribute('data-address');
		if (!markerChoose) return;

		const safeMarker = markerChoose.replace(/"/g, '\\"');
		const target = container.querySelector(`.js-map-item[data-id="${safeMarker}"] .js-open-acc`);
		if (target) {
			target.click();
		}
	}

	waitForGoogleMaps(timeout = 7000, interval = 200) {
		return new Promise((resolve, reject) => {
			const started = Date.now();
			(function check() {
				if (typeof window.google === 'object' && window.google.maps && window.google.maps.Map) {
					return resolve(window.google.maps);
				}
				if (Date.now() - started > timeout) {
					return reject(new Error('SelfPickup: Google Maps did not load in time'));
				}
				setTimeout(check, interval);
			})();
		});
	}

	loadGoogleMapForSelfPickup(googleMapJs) {
		if (window.google?.maps?.Map) {
			return Promise.resolve();
		}

		if (!googleMapJs) {
			return Promise.reject(new Error('SelfPickup: googleMapJs is missing'));
		}

		return new Promise((resolve, reject) => {
			const existing = document.getElementById('googleMapsScript');
			if (existing) {
				// Script can already be loading by other flows; wait for global object.
				this.waitForGoogleMaps(12000, 250).then(() => resolve()).catch(reject);
				return;
			}

			const script = document.createElement('script');
			script.id = 'googleMapsScript';
			script.src = googleMapJs;
			script.loading = 'async';
			script.async = true;
			script.defer = true;
			script.onload = () => resolve();
			script.onerror = () => reject(new Error('SelfPickup: failed to load Google Maps script'));
			document.head.appendChild(script);
		});
	}

	normalizeMapCoordinates(rawCoordinates) {
		const points = Array.isArray(rawCoordinates)
			? rawCoordinates
			: (rawCoordinates && typeof rawCoordinates === 'object' ? Object.values(rawCoordinates) : []);

		return points
			.map((point) => {
				const lat = Number(point?.lat);
				const lng = Number(point?.lng);
				if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
				return {
					...point,
					lat,
					lng,
				};
			})
			.filter(Boolean);
	}

	createInfoContent(mapItems, index) {
		const infoContent = document.createElement('div');
		const sourceItem = mapItems[index];
		if (!sourceItem) return infoContent;

		const clonedItem = sourceItem.cloneNode(true);
		clonedItem.classList.remove('js-map-item', 'js-acc');
		clonedItem.querySelectorAll('.js-acc-block').forEach((block) => {
			block.classList.remove('js-acc-block');
			block.style.removeProperty('max-height');
			block.style.removeProperty('overflow');
			block.style.removeProperty('transition');
		});
		clonedItem.removeAttribute('data-lat');
		clonedItem.removeAttribute('data-lng');
		clonedItem.classList.add('shop-item--infowindow');
		infoContent.appendChild(clonedItem);

		return infoContent;
	}

	handleMarkerClick(container, index, coord) {
		const mapItems = container.querySelectorAll('.js-map-item');
		const shopsList = container.querySelector('.js-shops-list');

		this._selfPickupInfoWindows.forEach(iw => iw.close());
		this._selfPickupInfoWindows[index]?.open(this._selfPickupMap, this._selfPickupMarkers[index]);
		this._selfPickupMap.setCenter(coord);
		this._selfPickupMap.setZoom(12);

		if (!mapItems[index]) return;

		mapItems.forEach(item => item.classList.remove('active'));
		mapItems[index].classList.add('active');

		const accBlock = mapItems[index].querySelector('.js-acc-block');
		if (accBlock) accBlock.style.maxHeight = 'initial';

		if (shopsList) {
			setTimeout(() => {
				shopsList.scrollTo({
					top: mapItems[index].offsetTop - shopsList.offsetTop,
					behavior: 'smooth'
				});
			}, 100);
		}
	}

	bindShopItemEvents(container) {
		if (!container || !this._selfPickupMap) return;

		container.querySelectorAll('.js-map-item').forEach((btn, index) => {
			if (btn.dataset.selfPickupMapBound === '1') return;
			btn.dataset.selfPickupMapBound = '1';

			const focusMap = () => {
				const lat = parseFloat(btn.getAttribute('data-lat'));
				const lng = parseFloat(btn.getAttribute('data-lng'));
				if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

				this._selfPickupMap.setCenter({lat, lng});
				this._selfPickupMap.setZoom(16);
				setTimeout(() => this._selfPickupMap.panBy(0, -80), 100);
				this._selfPickupInfoWindows.forEach(iw => iw.close());
				this._selfPickupInfoWindows[index]?.open(this._selfPickupMap, this._selfPickupMarkers[index]);
			};

			btn.addEventListener('click', (event) => {
				if (btn.dataset.type === 'secondary') {
					const clickedReserve = event.target.closest('.js-reserve-btn, .js-reserve');
					if (window.innerWidth > 743 && !clickedReserve) focusMap();
				} else {
					focusMap();
				}
			});
		});
	}

	updateSelectCity(parent) {
		const selectCity = parent.querySelector('.js-city-markers');
		const shopList = parent.querySelector('.js-shops-list');
		let abortController = null;

		if (!selectCity || selectCity.dataset.selfPickupCityBound === '1') return;
		selectCity.dataset.selfPickupCityBound = '1';

		selectCity.addEventListener('change', (event) => {
			const city = event.detail?.value;
			const url = selectCity.getAttribute('data-url');
			if (!city || !url) return;

			if (abortController) abortController.abort();
			abortController = new AbortController();

			axios.post(url, new URLSearchParams({settlementId: city}), {signal: abortController.signal})
				.then(async (response) => {
					const data = response.data || {};
					const normalizedCoordinates = this.normalizeMapCoordinates(data.coordinates);
					if (!normalizedCoordinates.length) return;

					if (shopList && data.items) {
						shopList.innerHTML = data.items;
					}

					const mapElement = parent.querySelector('.js-shop-map');
					if (!mapElement) return;

					mapElement.setAttribute('data-coordinates', JSON.stringify(data.coordinates || []));
					this._selfPickupMap = null;
					this._selfPickupMarkers = [];
					this._selfPickupInfoWindows = [];
					await this.initSelfPickupMap(parent);
				})
				.catch((error) => {
					if (error.name !== 'AbortError') {
						console.error('SelfPickup: failed to update city markers', error);
					}
				});
		});
	}

	async initSelfPickupMap(container) {
		const mapElement = container?.querySelector('.js-shop-map');
		if (!mapElement) return;

		let rawCoordinates = [];
		try {
			rawCoordinates = JSON.parse(mapElement.getAttribute('data-coordinates') || '[]');
		} catch (e) {
			console.error('SelfPickup: invalid map coordinates', e);
			return;
		}

		if (rawCoordinates && typeof rawCoordinates === 'object' && !Array.isArray(rawCoordinates)) {
			const mapItems = Array.from(container.querySelectorAll('.js-map-item'));
			const keyedCoordinates = mapItems
				.map((item) => rawCoordinates[item.getAttribute('data-id')])
				.filter(Boolean);
			if (keyedCoordinates.length) {
				rawCoordinates = keyedCoordinates;
			}
		}

		const coordinates = this.normalizeMapCoordinates(rawCoordinates);
		if (!coordinates.length) return;

		try {
			await this.waitForGoogleMaps();
		} catch (e) {
			console.error(e);
			return;
		}

		const mapDataZoom = mapElement.dataset.zoom;

		if (this._selfPickupMap) {
			// Reflow map after tab switch/open animation.
			window.google.maps.event.trigger(this._selfPickupMap, 'resize');
			if (mapDataZoom) {
				this._selfPickupMap.setCenter(coordinates[0]);
                        } else if (coordinates.length === 1) {
                                this._selfPickupMap.setCenter(coordinates[0]);
                                this._selfPickupMap.setZoom(12);
                        } else {
                                const bounds = new window.google.maps.LatLngBounds();
                                coordinates.forEach((coord) => bounds.extend(coord));
                                this._selfPickupMap.fitBounds(bounds);
                        }
			this.bindShopItemEvents(container);
			return;
		}

		const bounds = new window.google.maps.LatLngBounds();
		const mapItems = container.querySelectorAll('.js-map-item');
		this._selfPickupMap = new window.google.maps.Map(mapElement, {
			zoom: mapDataZoom ? Number(mapDataZoom) : 16,
			center: coordinates[0],
			disableDefaultUI: true,
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false,
		});

		this._selfPickupMarkers.forEach(marker => marker.setMap(null));
		this._selfPickupMarkers = [];
		this._selfPickupInfoWindows.forEach((infoWindow) => infoWindow.close());
		this._selfPickupInfoWindows = [];

		coordinates.forEach((coord, index) => {
			const marker = new window.google.maps.Marker({
				position: coord,
				map: this._selfPickupMap,
				icon: {
					url: coord.icon || mapElement.getAttribute('data-icon') || '/images/icons/map-marker-icon.svg',
					scaledSize: new window.google.maps.Size(26, 43),
				}
			});
			this._selfPickupMarkers.push(marker);
			const infoWindow = new window.google.maps.InfoWindow({
				content: this.createInfoContent(mapItems, index),
				pixelOffset: new window.google.maps.Size(0, -10),
			});
			this._selfPickupInfoWindows.push(infoWindow);
			marker.addListener('click', () => this.handleMarkerClick(container, index, coord));
			bounds.extend(marker.position);
		});

                if (!mapDataZoom) {
                        if (coordinates.length === 1) {
                                this._selfPickupMap.setCenter(coordinates[0]);
                                this._selfPickupMap.setZoom(14);
                        } else {
                                this._selfPickupMap.fitBounds(bounds);
                        }
                }

		this.bindShopItemEvents(container);
	}

	reserveFormSubmit(form) {
		const button = form.querySelector('button[type="submit"]');
		if (!form || !button) {
			console.error('SelfPickup: Reserve form or button not found');
			return;
		}
		this.rememberI18n(form);
		this.clearFormErrors(form);
		const formData = new FormData(form);
		const url = form.action || (this.baseUrl + '/orders/reserve');
		axios.post(url, formData)
			.then(async resp => {
				const data = resp.data;
				if (data.error) {
					this.makeModalClosable();
					button.disabled = false;
					return window.showErrorModal(data.error);
				}
				if (data.fields) {
					data.fields.forEach(f => {
						const field = form.querySelector(`[name="${f.field}"]`);
						if (field) {
							field.closest('.js-input-label')?.classList.add('field-error');
							const errorElement = document.querySelector(`#${f.field}-error`);
							if (errorElement) {
								errorElement.querySelector('.js-error-message').textContent = f.error;
								errorElement.style.display = 'block';
							}
						}
					});
					this.makeModalClosable();
					button.disabled = false;
					return;
				}
				if (data.loc) {
					window.location.href = data.loc;
					return;
				}
				if (data.body) {
					await replaceModalContentAndOpen({
						html: data.body,
						type: 'reserve-confirmation',
						id: 'global-popup',
						containerSel: '.js-append-popup'
					});
					this.makeModalStatic();
					return;
				}
				button.disabled = false;
			})
			.catch(err => {
				button.disabled = false;
				this.makeModalClosable();
				console.error('SelfPickup: Error submitting reserve form', err);
				window.showErrorModal(
					this.getI18n('i18nReserveSubmitError', 'Произошла ошибка при отправке формы. Попробуйте позже.', form)
				);
			});
	}

	clearFormErrors(form) {
		const errorFields = form.querySelectorAll('.field-error');
		errorFields.forEach(field => field.classList.remove('field-error'));
		const errorMessages = form.querySelectorAll('.error-message');
		errorMessages.forEach(msg => {
			msg.querySelector('.js-error-message').textContent = '';
			msg.style.display = 'none';
		});
	}
}
